import { createSlice } from '@reduxjs/toolkit';

export const showOpenPoint = createSlice({
  name: 'showOpenPoint',
  initialState: {
    data: false,
  },

  reducers: {
    setShowOpenPoint: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setShowOpenPoint } = showOpenPoint.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getShowOpenPoint = (state) => state.showOpenPoint.data;

export default showOpenPoint.reducer;
